import React, { useEffect, useState } from 'react'
import { Card, Checkbox } from 'antd'
import { inject, observer } from 'mobx-react'
import styled from 'styled-components'
import { blue } from '../../color'

const CardWrapper = styled(Card)`
  .ant-card-head {
    background-color: rgba(222, 242, 255, 1);
    color: #000;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom: 1px solid #e3e8ef;
  }
`

const ACLActionCard = props => {
  const { actionList, title, aclStore, type, setActionListStatus } = props

  const [actionUpdateList, setActionUpdateList] = useState([])
  const [checkAll, setCheckAll] = useState(false)

  useEffect(() => {
    setActionUpdateList(
      actionList.map(item => ({
        ...item,
        status: item.status || false,
      }))
    )
  }, [actionList])

  useEffect(() => {
    if (actionUpdateList.length === 0) return
    aclStore.setAclActionUpdateList([
      ...aclStore.aclActionUpdateList.filter(
        item => item.tag !== actionUpdateList[0].tag
      ),
      ...actionUpdateList,
    ])
    setCheckAll(actionUpdateList?.every(item => item.status))
  }, [actionUpdateList])

  const onChange = (status, code) => {
    const newActionList = [...actionUpdateList]
    const i = actionUpdateList.findIndex(item => item.code === code)
    if (i !== -1) {
      newActionList[i].status = status
    }
    setActionUpdateList(newActionList)
    setActionListStatus(prev => ({
      ...prev,
      [type]: newActionList?.every(item => item.status),
    }))
  }

  const onCheckAllChange = e => {
    const newActionList = actionUpdateList.map(item => ({
      ...item,
      status: e.target.checked,
    }))
    setActionUpdateList(newActionList)
    setCheckAll(e.target.checked)
    setActionListStatus(prev => ({
      ...prev,
      [type]: e.target.checked,
    }))
  }

  return (
    <CardWrapper
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '8px',
            marginLeft: '1px',
          }}>
          <Checkbox checked={checkAll} onChange={onCheckAllChange} />
          <span style={{ fontWeight: 600 }}>{title}</span>
        </div>
      }
      size={'small'}
      style={{
        borderRadius: 8,
        width: 300,
        // backgroundColor: 'rgba(0, 109, 178, 0.05)',
        backgroundColor: '#fff',
        boxShadow: '#E3E8EF 0px 1px 2px 0px',
      }}>
      <div
        style={{
          display: 'flex',
          gap: 6,
          flexDirection: 'column',
        }}>
        {actionUpdateList.map(item => (
          <div key={item.code}>
            <Checkbox
              checked={item.status}
              onChange={e => onChange(e.target.checked, item.code)}>
              {item.name}
            </Checkbox>
          </div>
        ))}
      </div>
    </CardWrapper>
  )
}

ACLActionCard.propTypes = {}
export default inject('aclStore')(observer(ACLActionCard))
